/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmRokDenikuSsl extends GContentBase<SeznamAdmRokDenikuSslObj> {
        private seznamObj: SeznamAdmRokDenikuSslObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmRokDenikuSslObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmRokDenikuSsl",
                contentCaption: "jres:33000612", //RC 33000612 : Roky podacího deníku
                dataListDescriptor: this.dataListDescription,
                filterSettings: {
                    addDefaultaktivita: false
                },
                comparatorSettings: {
                    itemTemplate: "{sslden} - {rok}"
                },
                gridSettings: {
                    columnOrder: "sslden,rok,por_cislo_od,por_cislo_do,por_cislo_max,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmRokDenikuSslObj extends GAdmSeznamBase {
        sslden: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmRokDenikuSsl", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmRokDenikuSsl",
                newRecord: isNew,
                sslden: isNew == true ? ((this.sslden) ? this.sslden : null) : data.sslden,
                rok: isNew == true ? null : data.rok
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29808057").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                name: "sslden",
                model: "model.sslden=value.sslden",
                dropdown: true,
                disabled: (this.sslden) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.sslden) 
                hardFilter["sslden"] = this.sslden
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.AdmRokDenikuSsl.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.sslden, data.rok),
                nazev: "{0} - {1}".format(data["sslden"], data["rok"])
            }
        }
    }
}